module.exports = __webpack_public_path__ + "img/8099105.jpg";